export default __webpack_public_path__ + "static/media/activities_white.50314384.svg";